import React, { FC, PropsWithChildren, useRef } from 'react';
import classNames from 'classnames';

import Button from 'vibo-ui/Button';
import OverlayGradient from '../OverlayGradient';
import ContentArea from 'components/common/ContentArea';

import { useModal } from 'vibo-ui/Modal';
import { useEvent } from 'components/context/EventContext';
import { useObserveVisible } from 'services/common/domHelpers';
import { AllTimelineGqlOptions, useTimeline } from 'components/events/Timeline/TimelineContext';

import { Modals } from 'types/enums';
import { IconmoonFont } from 'vibo-ui/Icon';
import { EventSettingsModalProps } from 'components/modals/EventSettingsModal';

import useStyles from './style';

const EventInfoCard: FC<PropsWithChildren> = ({ children }) => {
  const classes = useStyles();

  const { openModal } = useModal();
  const eventContext = useEvent();
  const timeline = useTimeline<AllTimelineGqlOptions>();

  const ref = useRef<HTMLDivElement | null>(null);

  useObserveVisible(ref, () => {
    const eventLayout = document.getElementById('eventLayout');
    eventLayout?.removeAttribute('scrolled');
  });

  const openEventSettingsModal = () =>
    openModal<EventSettingsModalProps>({
      key: Modals.eventSettings,
      props: {
        eventContext,
        variables: {
          [eventContext.isTemplate ? 'templateId' : 'eventId']: eventContext.event?._id,
        },
        mutation: timeline.event.mutations.update.mutation,
      },
    });

  return (
    <div
      className={classNames('eventInfoCardWrapper', classes.eventInfoCardWrapper, {
        withHash: eventContext.isEventDj && !eventContext.isHistory,
      })}
      ref={ref}
      onClick={e => {
        const el = e.target as Maybe<HTMLElement>;
        const hash = el?.dataset?.hash;

        if (hash && eventContext.isEventDj && !eventContext.isHistory) {
          window.location.hash = hash;

          openEventSettingsModal();
        }
      }}
    >
      <ContentArea className={classes.eventInfoCard} shadowed>
        {children}
      </ContentArea>
      <OverlayGradient />
      <Button
        onClick={() => {
          const scroll = document.querySelector('.eventLayoutContainer');

          scroll?.scrollTo({
            top: scroll?.scrollTop ? 0 : scroll.scrollHeight,
            behavior: 'smooth',
          });
        }}
        className="scrollArrow"
        prefixIcon={IconmoonFont['caretDown-16']}
        displayType="white"
        shape="circle"
        size="lg"
      />
    </div>
  );
};

export default EventInfoCard;
